import _ from 'lodash';
import { Reducer } from 'redux';
import { GetTermsOfUseContentsAction, GET_TERMS_OF_USE_CONTENTS } from './actions';
import { LogoutAction, LOGOUT } from 'store/user/actions';

export interface TermsofUsepageState {
  readonly id: number;
  readonly defaultFlag: boolean;
  readonly name: string;
  readonly page: string;
  readonly text: string;
}

export const defaultState: TermsofUsepageState = {
  id: 0,
  defaultFlag: false,
  name: '',
  page: '',
  text: '',
};

export const reducer: Reducer<TermsofUsepageState, GetTermsOfUseContentsAction | LogoutAction> = (
  state = defaultState,
  action,
) => {
  switch (action.type) {
    case GET_TERMS_OF_USE_CONTENTS:
      return {
        ...action.payload[0],
      };
    case LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
